import { LoadingButton } from "@mui/lab";
import { Alert, Grid, MenuItem, TextField, useMediaQuery } from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createProductThunk,
  updateProductThunk,
} from "store/reducers/product/productSlice";
import * as yup from "yup";
import SimpleBarScroll from "components/SimpleBar";
import { categorySelector } from "store/reducers/product/categorySlice";
import {
  getSubCategoriesThunk,
  subCategorySelector,
} from "store/reducers/product/subCategorySlice";
import AutoCompleteList from "components/AutoCompleteList";
import AutoCompleteListFormik from "components/AutoCompleteListFormik";

const validation = yup.object({
  // sub_category: yup.object("Choose category").required("Subcategory required"),
  name: yup.string("Enter name").required("Name required"),
  desc: yup.string("Enter desc"),
  validation_required: yup
    .boolean("Validation required")
    .required("Field is mandatory"),
});
const ProductCreate = ({ product = null, fullGrid = false, handleNext }) => {
  const dispatch = useDispatch();
  const [initialUpdateCat, setInitialUpdateCat] = useState(true);
  const [initialUpdateSubCat, setInitialUpdateSubCat] = useState(true);
  const formik = useFormik({
    initialValues: {
      sub_category: null,
      name: product?.name ?? "",
      desc: product?.desc ?? "",
      validation_required: product?.validation_required ?? false,
      product_type: product?.product_type ?? "none",
    },
    validationSchema: validation,
    onSubmit: (data) => {
      if (product) {
        dispatch(
          updateProductThunk({
            id: product.id,
            data: { ...data, sub_category: data.sub_category.id },
          })
        );
      } else {
        dispatch(
          createProductThunk({ ...data, sub_category: data.sub_category.id })
        );
      }
    },
    validateOnChange: false,
  });
  const { loading, error, success, errorMessage, currentProduct } = useSelector(
    (state) => state.product
  );

  const isFullWidth = useMediaQuery((theme) => theme.breakpoints.down("md"));

  useEffect(() => {
    if (errorMessage?.create) {
      Object.keys(errorMessage?.create).forEach((key) => {
        console.log(key, errorMessage?.create[key][0]);
        formik.setFieldError(key, errorMessage?.create[key][0]);
      });
    }
  }, [errorMessage]);

  useEffect(() => {
    if (errorMessage?.update?.id) {
      Object.keys(errorMessage?.update?.id).forEach((key) => {
        console.log(key, errorMessage?.update?.id[key][0]);
        formik.setFieldError(key, errorMessage?.update?.id[key][0]);
      });
    }
  }, [errorMessage]);

  const [category, setCategory] = useState(null);
  const [subCategory, setSubCategory] = useState(null);
  const categories = useSelector(categorySelector.selectAll);

  useEffect(() => {
    if (category) {
      setSubCategory(null);
      dispatch(getSubCategoriesThunk(category.id));
    }
  }, [category]);

  useEffect(() => {
    if (categories.length > 0) {
      if (product && initialUpdateCat) {
        const currentCategory = categories.find(
          (item) => item.id === product.category
        );
        console.log("current cat", currentCategory);
        if (currentCategory) {
          setCategory(currentCategory);
          setInitialUpdateCat(false);
        }
      }
    }
  }, [categories, product]);

  const subCategories = useSelector(subCategorySelector.selectAll).filter(
    (item) => item.category === category?.id
  );

  useEffect(() => {
    if (subCategories.length > 0) {
      if (product && initialUpdateSubCat) {
        const currentSubCategory = subCategories.find(
          (item) => item.id === product.sub_category
        );
        console.log("current sub", currentSubCategory);
        if (currentSubCategory) {
          // setSubCategory(currentSubCategory);
          formik.setFieldValue("sub_category", currentSubCategory);
          setInitialUpdateSubCat(false);
        }
      }
    }
  }, [subCategories, product]);

  useEffect(() => {
    if (currentProduct) {
      handleNext();
      console.log("next", currentProduct);
    }
  }, [currentProduct]);

  useEffect(() => {
    console.log("Started");
  });

  return (
    <>
      <SimpleBarScroll>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={1.5} paddingY={1}>
            <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4}>
              <AutoCompleteList
                items={categories}
                name="name"
                label="Filter categories"
                setValue={setCategory}
                value={category}
              />
            </Grid>

            <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4}>
              <AutoCompleteListFormik
                items={subCategories}
                name="name"
                label="Filter subcategories"
                formik={formik}
                formikName="sub_category"
                required={true}
              />
            </Grid>

            <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4}>
              <TextField
                label="Name"
                variant="outlined"
                name="name"
                fullWidth
                value={formik.values.name}
                onChange={formik.handleChange}
                error={Boolean(formik.errors.name)}
                helperText={formik.errors.name}
                autoComplete="new-password"
                required
              />
            </Grid>
            <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4}>
              <TextField
                label="Description"
                variant="outlined"
                name="desc"
                fullWidth
                value={formik.values.desc}
                onChange={formik.handleChange}
                error={Boolean(formik.errors.desc)}
                helperText={formik.errors.desc}
                autoComplete="new-password"
              />
            </Grid>

            <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4}>
              <TextField
                label="Validation required"
                variant="outlined"
                name="validation_required"
                select
                fullWidth
                value={formik.values.validation_required}
                onChange={formik.handleChange("validation_required")}
                error={Boolean(formik.errors.validation_required)}
                helperText={formik.errors.validation_required}
                autoComplete="new-password"
              >
                <MenuItem value={true}>Yes</MenuItem>
                <MenuItem value={false}>No</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4}>
              <TextField
                label="Product type"
                variant="outlined"
                name="product_type"
                select
                fullWidth
                value={formik.values.product_type}
                onChange={formik.handleChange("product_type")}
                error={Boolean(formik.errors.product_type)}
                helperText={formik.errors.product_type}
                autoComplete="new-password"
              >
                <MenuItem value="veg">Vegetarian</MenuItem>
                <MenuItem value="non-veg">Non vegetarian</MenuItem>
                <MenuItem value="none">None</MenuItem>
              </TextField>
            </Grid>
          </Grid>

          {((!product && error?.create) ||
            (product && error?.update === product.id)) && (
            <Alert sx={{ my: 1 }} severity="error">
              Error occurred
            </Alert>
          )}

          {((!product && success?.create) ||
            (product && success?.update === product.id)) && (
            <Alert sx={{ my: 1 }} severity="success">
              Success
            </Alert>
          )}
          <LoadingButton
            loading={
              (!product && loading?.create) ||
              (product && loading?.update === product.id)
            }
            variant="contained"
            fullWidth={isFullWidth}
            type="submit"
            sx={{ paddingX: 10, marginTop: 1 }}
          >
            {product ? "Update" : "Create"}
          </LoadingButton>
        </form>
      </SimpleBarScroll>
    </>
  );
};

export default ProductCreate;
